import React from 'react';

const statusConfig = {
  // Contract statuses
  pedido_chamada: {
    label: 'Pedido de Chamada',
    className: 'bg-blue-100 text-blue-700 border-blue-200',
  },
  validacao_documentos: {
    label: 'Validação de Documentos',
    className: 'bg-cyan-100 text-cyan-700 border-cyan-200',
  },
  chamada_efectuada: {
    label: 'Chamada Efectuada',
    className: 'bg-purple-100 text-purple-700 border-purple-200',
  },
  nao_atende: {
    label: 'Não Atende',
    className: 'bg-rose-100 text-rose-700 border-rose-300',
  },
  esclarecimentos: {
    label: 'Esclarecimentos',
    className: 'bg-amber-100 text-amber-700 border-amber-200',
  },
  esclarecimentos_respondidos: {
    label: 'Esclarec. Respondidos',
    className: 'bg-sky-100 text-sky-700 border-sky-200',
  },
  pendente_documentos: {
    label: 'Pendente de Documentos',
    className: 'bg-yellow-100 text-yellow-700 border-yellow-200',
  },
  anulado_comercializadora: {
    label: 'Anulado pela Comercializadora',
    className: 'bg-orange-100 text-orange-700 border-orange-200',
  },
  registado_comercializadora: {
    label: 'Registado na Comercializadora',
    className: 'bg-teal-100 text-teal-700 border-teal-200',
  },
  anulado: {
    label: 'Anulado',
    className: 'bg-red-100 text-red-700 border-red-200',
  },
  baixa: {
    label: 'Baixa',
    className: 'bg-amber-200 text-amber-900 border-amber-400',
  },
  concluido: {
    label: 'Concluído',
    className: 'bg-[#B8E02A]/20 text-[#7BA31D] border-[#B8E02A]/30',
  },
  // Legacy statuses (keeping for backwards compatibility)
  novo: {
    label: 'Novo',
    className: 'bg-blue-100 text-blue-700 border-blue-200',
  },
  contactado: {
    label: 'Contactado',
    className: 'bg-cyan-100 text-cyan-700 border-cyan-200',
  },
  proposta: {
    label: 'Proposta',
    className: 'bg-purple-100 text-purple-700 border-purple-200',
  },
  negociacao: {
    label: 'Negociação',
    className: 'bg-yellow-100 text-yellow-700 border-yellow-200',
  },
  cancelado: {
    label: 'Cancelado',
    className: 'bg-pink-100 text-pink-700 border-pink-200',
  },
  pendente: {
    label: 'Pendente',
    className: 'bg-orange-100 text-orange-700 border-orange-200',
  },
  // Ticket status
  em_tratamento: {
    label: 'Em Tratamento',
    className: 'bg-yellow-100 text-yellow-700 border-yellow-200',
  },
  // Priority
  baixa: {
    label: 'Baixa',
    className: 'bg-slate-100 text-slate-600 border-slate-200',
  },
  normal: {
    label: 'Normal',
    className: 'bg-blue-100 text-blue-700 border-blue-200',
  },
  alta: {
    label: 'Alta',
    className: 'bg-orange-100 text-orange-700 border-orange-200',
  },
  urgente: {
    label: 'Urgente',
    className: 'bg-red-100 text-red-700 border-red-200',
  },
  // Lead statuses
  nova: {
    label: 'Nova',
    className: 'bg-sky-100 text-sky-700 border-sky-200',
  },
  em_contacto: {
    label: 'Em Contacto',
    className: 'bg-blue-100 text-blue-700 border-blue-200',
  },
  reagendada: {
    label: 'Reagendada',
    className: 'bg-amber-100 text-amber-800 border-amber-300',
  },
  proposta: {
    label: 'Proposta',
    className: 'bg-violet-100 text-violet-700 border-violet-200',
  },
  convertida: {
    label: 'Convertida',
    className: 'bg-emerald-600 text-white border-emerald-700',
  },
  sem_interesse: {
    label: 'Sem Interesse',
    className: 'bg-slate-100 text-slate-600 border-slate-200',
  },
  invalida: {
    label: 'Inválida',
    className: 'bg-rose-100 text-rose-700 border-rose-200',
  },
};

export const StatusBadge = ({ status, className = '', size = 'sm' }) => {
  const config = statusConfig[status] || {
    label: status,
    className: 'bg-slate-100 text-slate-600 border-slate-200',
  };
  const sizeClass = size === 'lg'
    ? 'px-3 py-1 text-sm'
    : size === 'xs'
    ? 'px-1.5 py-0 text-[10px]'
    : 'px-2.5 py-0.5 text-xs';

  return (
    <span
      className={`inline-flex items-center ${sizeClass} rounded-full font-semibold border whitespace-nowrap ${config.className} ${className}`}
      data-testid={`status-badge-${status}`}
      title={config.label}
    >
      {config.label}
    </span>
  );
};

export const ServiceBadge = ({ service }) => {
  const serviceConfig = {
    luz_gas: { label: 'Luz e Gás', className: 'bg-yellow-100 text-yellow-700' },
    solar: { label: 'Solar', className: 'bg-orange-100 text-orange-700' },
    carregamento: { label: 'Carregamento', className: 'bg-green-100 text-green-700' },
    telecomunicacoes: { label: 'Telecomunicações', className: 'bg-purple-100 text-purple-700' },
    alarmes: { label: 'Alarmes', className: 'bg-red-100 text-red-700' },
  };

  const config = serviceConfig[service] || { label: service, className: 'bg-slate-100 text-slate-600' };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config.className}`}
      data-testid={`service-badge-${service}`}
    >
      {config.label}
    </span>
  );
};

export const SegmentBadge = ({ segment }) => {
  const segmentConfig = {
    residencial: { label: 'Residencial', className: 'bg-[#4DD4E8]/10 text-[#0e7490]' },
    empresarial: { label: 'Empresarial', className: 'bg-[#2D3E6F]/10 text-[#2D3E6F]' },
    condominio: { label: 'Condomínio', className: 'bg-purple-100 text-purple-700' },
  };

  const config = segmentConfig[segment] || { label: segment, className: 'bg-slate-100 text-slate-600' };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config.className}`}
      data-testid={`segment-badge-${segment}`}
    >
      {config.label}
    </span>
  );
};

export const ProductBadge = ({ product }) => {
  const productConfig = {
    luz: { label: 'Luz', className: 'bg-yellow-50 text-yellow-700' },
    gas: { label: 'Gás', className: 'bg-blue-50 text-blue-700' },
    luz_gas: { label: 'Luz + Gás', className: 'bg-green-50 text-green-700' },
  };

  const config = productConfig[product] || { label: product, className: 'bg-slate-100 text-slate-600' };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config.className}`}
      data-testid={`product-badge-${product}`}
    >
      {config.label}
    </span>
  );
};
